import React, { useState } from "react";

import Measurement_Uncertainty_table from "./measurement_Uncertainty_table/Measurement_Uncertainty_table";
import Measurement_Uncertainty_Form from "./measurement_Uncertainty_Form/Measurement_Uncertainty_Form";

function Measurement({onNext}) {
  return (
    <section className="Imperiality"> 
      <div className="imperiality_Form_div">
        <Measurement_Uncertainty_Form onNext={onNext}/>
      </div>

      <div className="imperiality_table_div">
        <Measurement_Uncertainty_table />
      </div>
    </section>
  );
}

export default Measurement;
